// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__W2ClS","empty":"Messages_empty__b6+c7"};